import React from 'react'

interface Props {
    string: string
    length: number
}
class Shorten extends React.Component<Props> {
    public static defaultProps = {
        string: '',
        length: -1,
    }

    public render() {
        if (typeof this.props.string !== 'string') {
            return <span className="string" />
        }

        if (this.props.length < 0 || this.props.string.length <= this.props.length) {
            return <span className="string word-break">{this.props.string}</span>
        }

        return (
            <span className="string word-break" data-toggle="tooltip" title={this.props.string}>
                {this.props.string.substr(0, this.props.length - 1)}…
            </span>
        )
    }
}

export default Shorten
